import { Button, Menu, MenuItem, MenuProps } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import React, { useState } from 'react';
import { useFindAllUtilitiesQuery } from '../../api/api-hooks';
import LinkNewTab from '../../components/LinkNewTab';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const UtilitiesWidget = () => {
  const { data: utils } = useFindAllUtilitiesQuery({});
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  if (utils === undefined) return null;
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        variant='outlined'
        color='primary'
        onClick={handleClick}
        aria-controls='customized-menu'
        aria-haspopup='true'
      >
        Get Utility Software
      </Button>
      <StyledMenu
        id='customized-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {utils.map((util, index) => (
          <MenuItem key={index}>
            <LinkNewTab href={util.link} label={util.name} />
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  );
};

export default UtilitiesWidget;
